import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=1db9a65b&scoped=true"
import script from "./EmailTemplates.vue?vue&type=script&lang=js"
export * from "./EmailTemplates.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplates.vue?vue&type=style&index=0&id=1db9a65b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db9a65b",
  null
  
)

/* custom blocks */
import block0 from "./EmailTemplates.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports